<template>
  <div id="list">
    <div class="container">
      <ul class="details">
        <div class="flex" v-if="!$utils.isArrayEmpty(dataList)" >
          <li
            v-for="(item,index) in dataList"
            :key="index">
            <el-card shadow="hover" :style="{'background':config.list}">
              <a @click="goTo(item.linkUrl,item.id,item.linkType)" class="flex bCenter column">
                <div class="cover">
                  <img :src="item.cover || item.coverUrl" :onerror="defaultImg">
                </div>
                <div class="detail-body flex column">
                  <div class="teacher flex middle" v-if="config.showTeacher">
                    <p><img :src="item.headUrl" alt=""></p>
                    <span>{{ item.name }}</span>
                  </div>
                  <div class="title text-overflow" :title="item.title" v-if="item.title" v-html="item.title"></div>
                  <div class="title text-overflow" :title="item.name" v-else>{{ item.name }}</div>

                  <div class="school flex bCenter middle" v-if="!config.showTeacher && config.showSchool">
                    <p class="schoolName text-overflow" :title="item.time" v-if="item.time">{{ item.time }}</p>
                    <p class="schoolName text-overflow" :title="item.schoolName" v-if="item.schoolName">{{ item.schoolName }}</p>
                    <p class="schoolName text-overflow" :title="item.subject+'、'+item.grade" v-else-if="item.subject && item.grade">{{ item.subject }} 、{{ item.grade }}</p>
                    <p class="schoolName text-overflow" :title="item.address" v-else-if="item.address">{{ item.address }}</p>
                    <p class="schoolName text-overflow" v-else>{{ $utils.myTimeToLocal(item.endTime,true) }}</p>

                    <p class="count flex middle" v-if="item.num">
                      <img :src="require('assets/images/online-learning/num.png')" alt="">
                      <span>{{ item.num }}</span>
                    </p>
                  </div>
                  <div class="reservation flex" v-if="config.showTeacher">
                    <el-button type="success">预约课程</el-button>
                  </div>
                </div>
              </a>
            </el-card>
          </li>
        </div>
        <div class="no-data" v-else>暂无数据</div>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  props:['config','dataList'],
  data(){
    return{
      //图片加载失败时加载默认图片
      defaultImg:'this.src="' + require('@/assets/images/item.png') + '"',
    }
  },
  methods:{
    goTo(linkUrl,pid,linkType){
      if(linkUrl){
        if(linkType){//外部链接
          window.location.href = linkUrl;
        }else{//路由跳转
          sessionStorage.setItem( "pid", pid );
          this.$router.push({
            path:linkUrl,
            query:this.$route.query
          })
        }
      }
    }
  },
}
</script>

<style lang="less" scoped>
@import './list.less';
</style>


